import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import { MatTabChangeEvent } from "@angular/material/tabs";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { ErrorType } from "src/app/enums/error-type.enum";
import endpoints from "src/app/helpers/endpoints";
import { ApiService } from "src/app/services/api.service";
import { CommonService } from "src/app/services/common.service";
import { StorageService } from "src/app/services/storage.service";


@Component({
  selector: "fury-partner-users-dashboard",
  templateUrl: "./partner-users-dashboard.component.html",
  styleUrls: ["./partner-users-dashboard.component.scss"],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class PartnerUsersDashboardComponent implements OnInit, OnDestroy {
  columns = [
    { name: "Added On", property: "addedOn", visible: true },
    { name: "Source", property: "source", visible: true },
    { name: "Total Cost", property: "soldAmount", visible: true },
    { name: "Result Code", property: "resultCode", visible: true },
    { name: "First Name", property: "firstName", visible: true },
    { name: "Last Name", property: "lastName", visible: true },
    { name: "Verified Name", property: "verifiedName", visible: true },
    { name: "Email", property: "emailAddress", visible: true },
    { name: "Mobile No", property: "mobileNumber", visible: true },
    { name: "Address", property: "address", visible: true },
    { name: "City", property: "city", visible: true },
    { name: "State", property: "state", visible: true },
    { name: "Zip Code", property: "zipCode", visible: true },
    { name: "Attempts", property: "attempts", visible: true },
    { name: "Status", property: "vanillaSoftStatus", visible: true },
    { name: "Last Agent Name", property: "lastAgentName", visible: true },
    { name: "Submission", property: "submission", visible: true },
    { name: "Last Date", property: "vanillaSoftTimestamps", visible: true },
    { name: "Lead Status", property: "leadStatus", visible: true },
    { name: "Actions", property: "actions", visible: true },
  ];
  callRailColumns = [
    { name: "Added On", property: "addedOn", visible: true },
    { name: "Utm Source", property: "utmSource", visible: true },
    { name: "Lead Source", property: "leadSource", visible: true },
    { name: "Result Code", property: "resultCode", visible: true },
    { name: "First Name", property: "firstName", visible: true },
    { name: "Last Name", property: "lastName", visible: true },
    { name: "Email", property: "emailAddress", visible: true },
    { name: "Mobile No", property: "mobileNumber", visible: true },
    { name: "Business Phone Number", property: "businessPhoneNumber", visible: true },
    { name: "Address", property: "address", visible: true },
    { name: "City", property: "city", visible: true },
    { name: "State", property: "state", visible: true },
    { name: "Zip Code", property: "zipCode", visible: true },
    { name: "Ip Address", property: "ipAddress", visible: true },
    { name: "Tracking Number", property: "trackingNumber", visible: true },
    { name: "Duration", property: "duration", visible: true },
    { name: "Lead Status", property: "leadStatus", visible: true },
    { name: "Sold Amount", property: "soldAmount", visible: true },
    { name: "Result Count", property: "resultCount", visible: true },
    {
      name: "Posted to Vanilla Soft",
      property: "isPostedToVanillaSoft",
      visible: true,
    },
    { name: "Actions", property: "actions", visible: true },
    // { name: "Internal Url", property: "internalUrl", visible: true },
  ];
  partnerId: string = null;
  ngUnsubscribe = new Subject<void>();
  itemList: any[] = [];
  pageSize = 30;
  totalCount: number = 0;
  pageIndex: number = 0;
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  partnerKpiData: any;
  selectConfig = { disableOptionCentering: true, panelClass: "custom-class" };
  isLoading: boolean = false;
  leadSearchForm = new FormGroup({
    source: new FormControl(""),
    firstName: new FormControl(""),
    lastName: new FormControl(""),
    verifiedName: new FormControl(""),
    emailAddress: new FormControl(""),
    mobileNumber: new FormControl(""),
    address: new FormControl(""),
    city: new FormControl(""),
    state: new FormControl(""),
    zip: new FormControl(""),
    attempts: new FormControl(""),
    resultCode: new FormControl(""),
    status: new FormControl(""),
    lastAgentName: new FormControl(""),
  });
  leadSourceTabName = "All";
  parentTabName = "All";
  leadSources: string[] = [];
  callRailLeadSearchForm = new FormGroup({
    firstName: new FormControl(""),
    lastName: new FormControl(""),
    utmSource: new FormControl(""),
    mobileNumber: new FormControl(""),
    emailAddress: new FormControl(""),
    leadSource: new FormControl(""),
    businessPhoneNumber: new FormControl("")
  });
  callRailPageSize = 30;
  callRailTotalCount: number = 0;
  callRailPageIndex: number = 0;
  callRailDataSource = [];

  constructor(
    private apiservice: ApiService,
    private storageService: StorageService,
    private router: Router,
    public commonService: CommonService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.partnerId = this.activatedRoute.snapshot.params["id"] || this.storageService.getUser()?.userId;
    this.activatedRoute.queryParams.pipe(takeUntil(this.ngUnsubscribe)).subscribe((res: any) => {
      this.pageIndex = res.page ? res.page - 1 : 0;
      this.pageSize = res.size ? (res.size === 'all' ? 9999 : res.size) : 30;
    });
    if (this.partnerId) {
      this.getPartnerUserKpiData();
      this.getPartnerLeadSource();
    }
  }

  getLeadsQueryParams() {
    const {source,firstName,lastName,verifiedName, emailAddress, mobileNumber, address, city, state,zip, attempts, resultCode, status, lastAgentName } = this.leadSearchForm.value;
    return `?page=${Number(this.pageIndex) + 1}&size=${this.pageSize}&source=${source}&firstName=${firstName}&lastName=${lastName}&verifiedName=${verifiedName}&emailAddress=${emailAddress}&phoneNumber=${mobileNumber}&address=${address}&city=${city}&state=${state}&zip=${zip}&attempts=${attempts}&resultCode=${resultCode}&status=${status}&lastAgentName=${lastAgentName}${this.leadSourceTabName !== "All" ? `&leadSource=${this.leadSourceTabName}` : ""}`;
  }

  getIncomingLeads() {
    this.apiservice
      .get(
        `${endpoints.leadManagement.getIncomingLeads(this.partnerId)}${this.getLeadsQueryParams()}`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: HttpResponse<any>) => {
          if (res.body) {
            if (res.body?.leads?.data) {
              this.itemList = res.body.leads?.data || [];
              this.totalCount = res.body.leads.total || 0;
              this.dataSource = new MatTableDataSource(this.itemList);
            } else {
              this.itemList = [];
              this.dataSource = new MatTableDataSource([]);
            }
          }
        },
        (error: HttpErrorResponse) => {
          this.apiservice.alert(error.message, ErrorType.Error);
        }
      );
  }
  getPartnerUserKpiData() {
    this.apiservice
      .get(`${endpoints.leadManagement.getPartnerUserKpiData(this.partnerId, this.parentTabName, this.leadSourceTabName)}`)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: HttpResponse<any>) => {
          if (res.body) {
            this.partnerKpiData = res.body;
          }
        },
        (error: HttpErrorResponse) => {
          this.apiservice.alert(error.message, ErrorType.Error);
        }
      );
  }

  pageSizeChange(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.getIncomingLeads();
  }
  callRailPageSizeChange(event: any) {
    this.callRailPageSize = event.pageSize;
    this.callRailPageIndex = event.pageIndex;
    this.getPartnerCallRailLeads();
  }

  navigateDetailsPage(data: any) {
    this.router.navigateByUrl(
      "/lead/lead-details/" + data.leadId + "?type=customerInformation"
    );
  }
  handleSearch(event: any) {
    this.getIncomingLeads();
  }
  callRailHandleSearch(event: any) {
    this.getPartnerCallRailLeads();
  }
  onTabChange(event: any) {
    this.leadSourceTabName = event.tab?.textLabel;
    this.pageIndex = 0;
    this.callRailPageIndex = 0;
    if(this.parentTabName === "Web"){
      this.leadSearchForm.setValue(this.leadSearchForm.value as any);
      this.leadSearchForm.updateValueAndValidity();
      this.getIncomingLeads();
    } 
    if(this.parentTabName === "Phone") {
      this.callRailLeadSearchForm.setValue(this.callRailLeadSearchForm.value as any);
      this.callRailLeadSearchForm.updateValueAndValidity();
      this.getPartnerCallRailLeads();
    }
    this.getPartnerUserKpiData();
  }
  parentTabChange(event: any) {
    this.leadSourceTabName = "All";
    this.parentTabName = event.tab?.textLabel;
    this.onTabChange({tab: {textLabel: this.leadSourceTabName}});
  }
  getPartnerLeadSource(){
    this.apiservice.get(`${endpoints.leadManagement.getPartnerLeadSource(this.partnerId)}`)
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(
      (res: HttpResponse<any>) => {
        if (res.body) {
          this.leadSources = res.body?.leadSources || [];
          this.leadSources.unshift("All");
        }
      },
      (error: HttpErrorResponse) => {
        this.apiservice.alert(error.message, ErrorType.Error);
      }
    );
  }
  getPartnerCallRailLeads() {
    const queryParams = `?page=${
          Number(this.callRailPageIndex) + 1
        }&size=${this.callRailPageSize}&firstName=${
          this.callRailLeadSearchForm.value.firstName || ""
        }&lastName=${this.callRailLeadSearchForm.value.lastName || ""}&mobileNumber=${
          this.callRailLeadSearchForm.value.mobileNumber || ""
        }&emailAddress=${
          this.callRailLeadSearchForm.value.emailAddress || ""
        }&utmSource=${this.callRailLeadSearchForm.value.utmSource || ""}&leadSource=${
          this.callRailLeadSearchForm.value.leadSource || ""
        }&businessPhoneNumber=${this.callRailLeadSearchForm.value.businessPhoneNumber}`
    this.apiservice
      .get(
        `${endpoints.leadManagement.getPartnerCallRailLeads(
          this.partnerId,
          this.leadSourceTabName
        )}${queryParams}`
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body) {
            this.callRailDataSource = res.body.callRailLeads?.data || [];
            this.callRailTotalCount = res.body.callRailLeads.total || 0;
          }
        },
        error: (error: HttpErrorResponse) => {
          this.apiservice.alert(error.message, ErrorType.Error);
        },
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
